module.exports = __webpack_public_path__ + "img/kh4@2x.58d36dff.png";